import { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router';
import {
    Dialog,
    DialogBackdrop,
    DialogPanel,
    DialogTitle,
} from '@headlessui/react';
import { Button } from '../buttons/Button';
import { cn } from '../../lib/helpers';

const TABS = [
    { label: 'Plán', to: '/plan-na-miru' },
    { label: 'Výsledky', to: '/plan-na-miru/vysledky' },
];

export function PlanTabs() {
    const location = useLocation();
    const navigate = useNavigate();
    const [confirmOpen, setConfirmOpen] = useState(false);

    return (
        <>
            <div
                role="tablist"
                className="flex flex-wrap items-center gap-3"
            >
                {TABS.map((tab) => {
                    const active = location.pathname === tab.to;
                    return (
                        <Link key={tab.to} to={tab.to}>
                            <span
                                role="tab"
                                className={cn(
                                    'inline-block rounded-xl px-4 py-2 font-medium transition-colors',
                                    active
                                        ? 'bg-product-500 text-white shadow-sm'
                                        : 'text-ink-900 hover:bg-cloud-200'
                                )}
                            >
                                {tab.label}
                            </span>
                        </Link>
                    );
                })}

                <button
                    type="button"
                    onClick={() => setConfirmOpen(true)}
                    className="rounded-xl px-4 py-2 font-medium text-ink-900 transition-colors hover:bg-cloud-200"
                >
                    Nový plán
                </button>
            </div>

            <Dialog
                open={confirmOpen}
                onClose={() => setConfirmOpen(false)}
                className="relative z-50"
            >
                <DialogBackdrop
                    transition
                    className={cn(
                        'fixed inset-0 bg-black/75',
                        'transition-opacity duration-200 data-[closed]:opacity-0'
                    )}
                />
                <div className="fixed inset-0 w-screen overflow-y-auto p-4">
                    <div className="flex min-h-full w-full items-center justify-center">
                        <DialogPanel
                            transition
                            className={cn(
                                'w-full max-w-dialog-md rounded-xl bg-base-100 p-8 shadow-lg',
                                'transition-all duration-200 data-[closed]:translate-y-4 data-[closed]:scale-95 data-[closed]:opacity-0'
                            )}
                        >
                            <DialogTitle as="h3" className="mb-2">
                                Sestavit nový plán?
                            </DialogTitle>
                            <p className="mb-6 text-ink-800">
                                Nový plán vznikne z nového vyplnění dotazníku a
                                nahradí ten stávající včetně vašeho dosavadního
                                postupu. Tuto akci nelze vzít zpět.
                            </p>
                            <div className="flex justify-end gap-4">
                                <Button
                                    color="product"
                                    variant="secondary"
                                    onClick={() => setConfirmOpen(false)}
                                >
                                    Zrušit
                                </Button>
                                <Button
                                    color="product"
                                    onClick={() =>
                                        navigate('/plan-na-miru/dotaznik')
                                    }
                                >
                                    Sestavit nový
                                </Button>
                            </div>
                        </DialogPanel>
                    </div>
                </div>
            </Dialog>
        </>
    );
}
